'use client';

import { DownloadSectionProps } from './types';
import { Headline } from '../headline/Headline';
import { Button } from '../button/Button';
import { BaseImage } from '@/components/baseImage/BaseImage';

export function DownloadSection({
  title,
  subtitle,
  button,
}: DownloadSectionProps) {
  return (
    <div className="relative flex h-[320px] flex-col items-center justify-center text-center">
      <BaseImage
        image={{ url: '/de/Header.jpg' }}
        width="2000"
        height="500"
        alt="Header"
        className="absolute inset-0 h-full w-full object-cover"
        classNameImage="h-full w-full object-cover"
        prerender
        sizes="100vw"
      />
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6">
        <Headline title={title} variant="headingTwo" className="text-white" />
        <Headline
          title={subtitle}
          variant="baseTextM"
          className="!font-normal text-white"
        />
        {button && <Button {...button} className="my-4" />}
      </div>
    </div>
  );
}

export default DownloadSection;
